import { render } from "./ChatNewMessage.vue?vue&type=template&id=f30e4a4c&scoped=true"
import script from "./ChatNewMessage.vue?vue&type=script&lang=js"
export * from "./ChatNewMessage.vue?vue&type=script&lang=js"

import "./ChatNewMessage.vue?vue&type=style&index=0&id=f30e4a4c&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f30e4a4c"]])

export default __exports__